import CloseIcon from 'app/ui/icons/CloseIcon';

import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';

export interface CancelButtonProps {
  onAction: () => void;
}

export default function CancelButton(props: CancelButtonProps) {
  const { onAction } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {!matches && (
        <Button variant="outlined" className="error" onClick={() => onAction()}>
          Cancel
        </Button>
      )}

      {matches && (
        <IconButton aria-label="Delete" className="error outlined" onClick={() => onAction()}>
          <CloseIcon />
        </IconButton>
      )}
    </>
  );
}
